<template>
  <div class="table-group">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "TableGroup",
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.table-group {
  :deep(> .table-box) {
    margin-bottom: 40px;
    @include mq-up(md) {
      margin-bottom: 60px;
    }
  }
  :deep(.heading-two:nth-child(n + 2)) {
    margin-top: 120px;
  }
}
</style>
